import type { FinderBudgetPreset } from './useFinder.types'

export function isBudgetPresetSelected(
  priceInput: [number, number] | undefined,
  preset: FinderBudgetPreset,
  inventoryFloor = 0,
): boolean {
  if (!priceInput) return false

  return priceInput[0] === inventoryFloor && priceInput[1] === preset.maxValue
}
